import { HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '../service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit {
  forgotPasswordForm: FormGroup;
  flag: boolean;
  showMessage: string;
  loading = false;
  submitted = false;
  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
  ) { }

  ngOnInit() {
    this.forgotPasswordForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
  });
  }
  private getParams(email:string) {
    return new HttpParams()
       
        .set('scope', 'read write')
        .set('username', email)
      
}
  get f() { return this.forgotPasswordForm.controls; }
  forgot(forgotPasswordForm: FormGroup) {
    this.submitted = true;
    if (this.forgotPasswordForm.invalid) {
        return;
    }
    this.loading = true;
    this.authenticationService.forgotPassword(forgotPasswordForm.value.email)
        .subscribe(
            data => {
              this.loading = false;
              this.showMessage ="You'll receive a new password  via email shortly. If you don't see it, please check your spam folder.";
              this.flag = true;
            },
            error => {
                this.loading = false;
                this.showMessage = error;
                this.flag = true;
            });
}

}
